import { ReactComponent as BathingPlatform } from './aft_bathing_platform.svg';
import { ReactComponent as AirConditioning } from './air_conditioning.svg';
import { ReactComponent as BarbequeGrill } from './barbeque_grill.svg';
import { ReactComponent as BathTowels } from './bath_towels.svg';
import { ReactComponent as BathingLadder } from './bathing_ladder.svg';
import { ReactComponent as BeachTowel } from './beach_towel.svg';
import { ReactComponent as Towels } from './beach_towel.svg';
import { ReactComponent as BedLinen } from './bed_linen.svg';
import { ReactComponent as Bicycle } from './bicycle.svg';
import { ReactComponent as BowThruster } from './bow_thruster.svg';
import { ReactComponent as Camera } from './camera.svg';
import { ReactComponent as CaptainsHat } from './captains_hat.svg';
import { ReactComponent as AutoPilot } from './captains_hat.svg';
import { ReactComponent as Skipper } from './captains_hat.svg';
import { ReactComponent as CaptainsHatOutlined } from './captains_hat_outlined.svg';
import { ReactComponent as EarlyCheckin } from './checkin.svg';
import { ReactComponent as LateCheckin } from './checkin.svg';
import { ReactComponent as LateCheckout } from './checkin.svg';
import { ReactComponent as Cleaning } from './cleaning.svg';
import { ReactComponent as CockpitSpeaker } from './cockpit_speaker.svg';
import { ReactComponent as Bimini } from './cockpit_table.svg';
import { ReactComponent as CockpitTable } from './cockpit_table.svg';
import { ReactComponent as CoffeeMachine } from './coffee_machine.svg';
import { ReactComponent as Cook } from './cook.svg';
import { ReactComponent as DeckHand } from './deck_hand.svg';
import { ReactComponent as DeckShower } from './deck_shower.svg';
import { ReactComponent as DeliveryCharge } from './delivery_charge.svg';
import { ReactComponent as DepthSounder } from './depth_sounder.svg';
import { ReactComponent as Dinghy } from './dinghy.svg';
import { ReactComponent as DinghyMotor } from './dinghy_motor.svg';
import { ReactComponent as Dishwasher } from './dishwasher.svg';
import { ReactComponent as DiverDownFlag } from './diver_down_flag.svg';
import { ReactComponent as DivingFins } from './diving_fins.svg';
import { ReactComponent as Drone } from './drone.svg';
import { ReactComponent as ElectricScooter } from './electric_scooter.svg';
import { ReactComponent as ElectricToilet } from './electric_toilet.svg';
import { ReactComponent as ElectricWindlass } from './electric_windlass.svg';
import { ReactComponent as Fans } from './fans.svg';
import { ReactComponent as FireExtinguisher } from './fire_extinguisher.svg';
import { ReactComponent as FishFinder } from './fish_finder.svg';
import { ReactComponent as FishingRod } from './fishing_rod.svg';
import { ReactComponent as FishingTackle } from './fishing_tackle.svg';
import { ReactComponent as Flare } from './flare.svg';
import { ReactComponent as FloatationDevice } from './floatation_device.svg';
import { ReactComponent as FogBell } from './fog_bell.svg';
import { ReactComponent as FoilBoard } from './foil_board.svg';
import { ReactComponent as Freezer } from './freezer.svg';
import { ReactComponent as Fridge } from './fridge.svg';
import { ReactComponent as Fuel } from './fuel.svg';
import { ReactComponent as FullBoard } from './full_board.svg';
import { ReactComponent as HalfBoard } from './full_board.svg';
import { ReactComponent as FurlingMainSail } from './furling_genoa.svg';
import { ReactComponent as FurlingGenoa } from './furling_genoa.svg';
import { ReactComponent as GPS } from './gps.svg';
import { ReactComponent as GuidesAndMaps } from './guides_maps.svg';
import { ReactComponent as Charts } from './guides_maps.svg';
import { ReactComponent as Heating } from './heating.svg';
import { ReactComponent as Horn } from './horn.svg';
import { ReactComponent as Hostess } from './hostess.svg';
import { ReactComponent as HotWater } from './hot_water.svg';
import { ReactComponent as Insurance } from './insurance.svg';
import { ReactComponent as Inverter } from './inverter.svg';
import { ReactComponent as JetSki } from './jet_ski.svg';
import { ReactComponent as Kayak } from './kayak.svg';
import { ReactComponent as KiteSurf } from './kite_surf.svg';
import { ReactComponent as LifeJacket } from './life_jacket.svg';
import { ReactComponent as MaskAndSnorkel } from './mask_and_snorkel.svg';
import { ReactComponent as MedicalKit } from './medical_kit.svg';
import { ReactComponent as Microwave } from './microwave.svg';
import { ReactComponent as DrySuit } from './oilskins.svg';
import { ReactComponent as Oilskins } from './oilskins.svg';
import { ReactComponent as OneWayFee } from './one_way_fee.svg';
import { ReactComponent as Other } from './other.svg';
import { ReactComponent as OvenHob } from './oven_hob.svg';
import { ReactComponent as PaddleBoard } from './paddle_board.svg';
import { ReactComponent as NationalParkFee } from './park_fees.svg';
import { ReactComponent as Parking } from './parking.svg';
import { ReactComponent as AirportPickup } from './parking.svg';
import { ReactComponent as PlugSocket } from './plug_socket.svg';
import { ReactComponent as PortCharge } from './port_charge.svg';
import { ReactComponent as Provisioning } from './provisioning.svg';
import { ReactComponent as SafetyNet } from './safety_net.svg';
import { ReactComponent as HandheldRadio } from './satellite_phone.svg';
import { ReactComponent as SatellitePhone } from './satellite_phone.svg';
import { ReactComponent as Scooter } from './scooter.svg';
import { ReactComponent as SeaScooter } from './seascooter.svg';
import { ReactComponent as SolarPanels } from './solar_panels.svg';
import { ReactComponent as Spinnaker } from './spinnaker.svg';
import { ReactComponent as StormJib } from './storm_jib.svg';
import { ReactComponent as StrobeLight } from './strobe_light.svg';
import { ReactComponent as Sundeck } from './sundeck.svg';
import { ReactComponent as TeakDeck } from './teak_deck.svg';
import { ReactComponent as TouristLevy } from './tourist_levy.svg';
import { ReactComponent as TowRope } from './tow_rope.svg';
import { ReactComponent as TowedToys } from './towed_toys.svg';
import { ReactComponent as Tv } from './tv.svg';
import { ReactComponent as USBSocket } from './usb_socket.svg';
import { ReactComponent as VHF } from './vhf.svg';
import { ReactComponent as Wakeboard } from './wakeboard.svg';
import { ReactComponent as WasherDryer } from './washer_dryer.svg';
import { ReactComponent as WaterSki } from './water_ski.svg';
import { ReactComponent as Watermaker } from './watermaker.svg';
import { ReactComponent as WaterSkis } from './waterskis.svg';
import { ReactComponent as Wifi } from './wi-fi.svg';

const icons: any = {
  airport_pickup: { icon: AirportPickup },
  captainsHat: { icon: CaptainsHat },
  captainsHatOutlined: { icon: CaptainsHatOutlined },
  camera: { icon: Camera },
  charts: { icon: Charts },
  autopilot: { icon: AutoPilot },
  plug_socket: { icon: PlugSocket },
  aft_bathing_platform: { icon: BathingPlatform },
  air_conditioning: { icon: AirConditioning },
  barbeque_grill: { icon: BarbequeGrill },
  bath_towels: { icon: BathTowels },
  bathing_ladder: { icon: BathingLadder },
  beach_towel: { icon: BeachTowel },
  bed_linen: { icon: BedLinen },
  bicycle: { icon: Bicycle },
  bimini: { icon: Bimini },
  bow_thruster: { icon: BowThruster },
  cleaning: { icon: Cleaning },
  cockpit_speaker: { icon: CockpitSpeaker },
  cockpit_table: { icon: CockpitTable },
  coffee_machine: { icon: CoffeeMachine },
  cook: { icon: Cook },
  deck_hand: { icon: DeckHand },
  deck_shower: { icon: DeckShower },
  delivery_charge: { icon: DeliveryCharge },
  depth_sounder: { icon: DepthSounder },
  dinghy: { icon: Dinghy },
  dinghy_motor: { icon: DinghyMotor },
  diver_down_flag: { icon: DiverDownFlag },
  diving_fins: { icon: DivingFins },
  drone: { icon: Drone },
  dry_suit: { icon: DrySuit },
  early_checkin: { icon: EarlyCheckin },
  electric_scooter: { icon: ElectricScooter },
  electric_toilet: { icon: ElectricToilet },
  electric_windlass: { icon: ElectricWindlass },
  fans: { icon: Fans },
  fire_extinguisher: { icon: FireExtinguisher },
  fish_finder: { icon: FishFinder },
  fishing_rod: { icon: FishingRod },
  fishing_tackle: { icon: FishingTackle },
  flare: { icon: Flare },
  fog_bell: { icon: FogBell },
  foil_board: { icon: FoilBoard },
  freezer: { icon: Freezer },
  fridge: { icon: Fridge },
  furling_genoa: { icon: FurlingGenoa },
  furling_main_sail: { icon: FurlingMainSail },
  fuel: { icon: Fuel },
  full_board: { icon: FullBoard },
  gps: { icon: GPS },
  guides_maps: { icon: GuidesAndMaps },
  handheld_radio: { icon: HandheldRadio },
  half_board: { icon: HalfBoard },
  heating: { icon: Heating },
  horn: { icon: Horn },
  hostess: { icon: Hostess },
  hot_water: { icon: HotWater },
  inverter: { icon: Inverter },
  insurance: { icon: Insurance },
  jet_ski: { icon: JetSki },
  kite_surf: { icon: KiteSurf },
  kayak: { icon: Kayak },
  late_checkin: { icon: LateCheckin },
  late_checkout: { icon: LateCheckout },
  life_jacket: { icon: LifeJacket },
  mask_and_snorkel: { icon: MaskAndSnorkel },
  medical_kit: { icon: MedicalKit },
  microwave: { icon: Microwave },
  park_fees: { icon: NationalParkFee },
  oilskins: { icon: Oilskins },
  oven_hob: { icon: OvenHob },
  one_way_fee: { icon: OneWayFee },
  other: { icon: Other },
  paddle_board: { icon: PaddleBoard },
  parking: { icon: Parking },
  port_charge: { icon: PortCharge },
  provisioning: { icon: Provisioning },
  safety_net: { icon: SafetyNet },
  satellite_phone: { icon: SatellitePhone },
  scooter: { icon: Scooter },
  sea_scooter: { icon: SeaScooter },
  skipper: { icon: Skipper },
  solar_panels: { icon: SolarPanels },
  spinnaker: { icon: Spinnaker },
  storm_jib: { icon: StormJib },
  strobe_light: { icon: StrobeLight },
  sundeck: { icon: Sundeck },
  teak_deck: { icon: TeakDeck },
  towed_toys: { icon: TowedToys },
  floatation_device: { icon: FloatationDevice },
  tourist_levy: { icon: TouristLevy },
  towels: { icon: Towels },
  tow_rope: { icon: TowRope },
  tv: { icon: Tv },
  usb_socket: { icon: USBSocket },
  vhf: { icon: VHF },
  wakeboard: { icon: Wakeboard },
  water_ski: { icon: WaterSki },
  watermaker: { icon: Watermaker },
  'wi-fi': { icon: Wifi },
  dishwasher: { icon: Dishwasher },
  washer_dryer: { icon: WasherDryer },
  waterskis: { icon: WaterSkis },
};
export const fetchIcon = (name?: string, size?: number, color?: string) => {
  if (name) {
    const fetchedIcon = icons[name];
    if (fetchedIcon)
      return (
        <fetchedIcon.icon style={{ fill: color }} height={size} width={size} />
      );
  }
  const fetchedIcon = icons['captains_hat'];
  if (fetchedIcon)
    return (
      <fetchedIcon.icon style={{ fill: color }} height={size} width={size} />
    );
  return null;
};
export default icons;
